import * as React from 'react'
import { Popover } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import SimpleSearch from '../SimpleSearch'
import AdvancedSearch from '../AdvancedSearch'
import { setAdvancedSearch } from '../../redux/slices/Search/input'

const anchorO = {
  vertical: 'top',
  horizontal: 'right',
}
const transformO = {
  vertical: 'top',
  horizontal: 'left',
}

const PopoverSearch = ({ id, open, position, anchorEl, onClose }) => {
  const dispatch = useDispatch()
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth)
  const { advancedSearch, advancedSearchUsed, basicList, filtersList } = useSelector(
    state => state.filterSearch
  )
  const PAPER_PROPS = {
    sx: {
      px: 1.5,
      pt: 2,
      pb: 1,
      maxHeight: 'calc(100vh - 150px)',
      width: !advancedSearch && Boolean(basicList.type) ? 'calc(100vw - 70px)' : 'auto',
      maxWidth: !advancedSearch ? 800 : 'auto',
    },
  }
  const propsDefault = { open, advancedSearch, windowWidth }
  const propAS = { ...propsDefault, advancedSearchUsed, filtersList }
  const propSS = { ...propsDefault, basicList }

  React.useEffect(() => {
    if (!open) return
    if (advancedSearch !== advancedSearchUsed)
      dispatch(setAdvancedSearch(advancedSearchUsed))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  React.useEffect(() => {
    window.addEventListener('resize', () => setWindowWidth(window.innerWidth))
    return () => {
      window.removeEventListener('resize', () => setWindowWidth(window.innerWidth))
    }
  }, [])

  return (
    <Popover
      anchorReference="anchorPosition"
      anchorPosition={position}
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorO}
      transformOrigin={transformO}
      PaperProps={PAPER_PROPS}>
      {!advancedSearch ? <SimpleSearch {...propSS} /> : <AdvancedSearch {...propAS} />}
    </Popover>
  )
}
export default PopoverSearch
